import ProgressBar from "@ramonak/react-progress-bar";
import { Col, List, Row, Skeleton, Steps } from "antd";
import { memo, useEffect, useState } from "react";
import { BiChevronDown, BiChevronRight, BiChevronUp } from "react-icons/bi";
import { IoIosCheckboxOutline, IoMdCheckbox } from "react-icons/io";
import { IoRadioButtonOffSharp, IoRadioButtonOn } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import { EventMiddleware } from "../../../../../Store/Middlewares/EventMiddleware";
import peopleImg from "../../../../../assets/people1.png";
import {
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import useWindowDimensions from "../../../../../hooks/useWindowDimensions";
import styles from "./PlanningFormSection.module.css";
import dummy from "../../../../../assets/dummy.png";

const description = "This is a description.";

const planningItems = [
  {
    title: "General",
    progress: 75,
  },
  {
    title: "Photography",
    progress: 100,
  },
  {
    title: "Decoration",
    progress: 100,
  },
  {
    title: "DJ",
    progress: 100,
  },
];

const RenderPlanningItem = memo(
  ({ title, progress, setTopic, item, index }) => {
    const navigate = useNavigate();
    return (
      <List.Item
        className={styles.itemRow}
        onClick={() => {
          // getClientQueston(item?.id);
          // setTopic(item);
          navigate("/events/eventDetail/planningForm", {
            state: { headrTitle: `Planning Form`, item },
          });
        }}
      >
        <Col xs={20}>
          <Row>
            <TextComponent textClass={styles.itemTitle}>{title}</TextComponent>
          </Row>
          {/* <Row className={styles.progressBarRow}>
            <ProgressBar
              completed={progress}
              className={styles.bar}
              maxCompleted={100}
              labelClassName={styles.labelBar}
              bgColor="var(--primary-color)"
              height="6px"
            />
            <TextComponent textClass={styles.progressText}>
              {parseInt(progress)}%
            </TextComponent>
          </Row> */}
        </Col>
        <Col xs={4} className={styles.iconCol}>
          <BiChevronRight style={{ fontSize: "2rem" }} />
        </Col>
      </List.Item>
    );
  }
);

// const RenderQuestion = memo(
//   ({
//     item,
//     index,
//     onPressRadioButton,
//     onPressCheckBox,
//     answerByClient,
//     onValueChange,
//   }) => {
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     let ownwords = answerByClient.find(
//       (element) => element?.question_id == item.id
//     );

//     let isAnswered = item?.answer?.length > 0 ? true : false;
//     // console.log(item);
//     return (
//       <List.Item className={styles.rightColRow}>
//         <Col xs={24}>
//           <Row className={styles.questionRow}>
//             <Col xs={22}>
//               <Row className={styles.question}>
//                 <TextComponent textClass={styles.questionText}>
//                   <TextComponent textClass={styles.prefix}>
//                     {item.prefix}
//                   </TextComponent>
//                   &nbsp;
//                   {item?.question} #{index + 1}
//                 </TextComponent>
//               </Row>
//               {dropdownOpen && (
//                 <div className={styles.optionsContainer}>
//                   {item.type == "set_option" &&
//                     item?.options?.map((option) => {
//                       let find = answerByClient.find(
//                         (element) => element?.answer_id == option?.id
//                       );

//                       let findAnswer =
//                         option.name == item.answer ? true : false;
//                       return (
//                         <Row className={styles.option} key={option?.id}>
//                           <Col style={{ flex: 1 }}>
//                             <Row
//                               style={{ cursor: "pointer" }}
//                               onClick={
//                                 item?.is_answer == 0
//                                   ? () =>
//                                       onPressRadioButton(
//                                         option?.name,
//                                         option?.id,
//                                         item?.type,
//                                         item?.id
//                                       )
//                                   : null
//                               }
//                             >
//                               <Col xs={1}>
//                                 {find || findAnswer ? (
//                                   <IoRadioButtonOn
//                                     size={30}
//                                     color="var(--primary-color)"
//                                   />
//                                 ) : option?.answer ? (
//                                   <IoRadioButtonOn
//                                     size={30}
//                                     color="var(--primary-color)"
//                                   />
//                                 ) : (
//                                   <IoRadioButtonOffSharp
//                                     size={30}
//                                     color="var(--primary-color)"
//                                   />
//                                 )}
//                               </Col>
//                               <Col xs={22}>
//                                 <TextComponent textClass={styles.optionText}>
//                                   {option?.name}
//                                 </TextComponent>
//                               </Col>
//                             </Row>
//                           </Col>
//                         </Row>
//                       );
//                     })}

//                   {item.type == "multiple_option" &&
//                     item?.options?.map((option) => {
//                       let find = answerByClient.find(
//                         (element) => element?.answer_id == option?.id
//                       );
//                       let findAnswer = item.answer?.includes(option?.name);

//                       return (
//                         <Row className={styles.option} key={option?.id}>
//                           <Col style={{ flex: 1 }}>
//                             <Row
//                               style={{ cursor: "pointer" }}
//                               onClick={
//                                 item?.is_answer == 0
//                                   ? () =>
//                                       onPressCheckBox(
//                                         option?.name,
//                                         option?.id,
//                                         item?.type,
//                                         item?.id
//                                       )
//                                   : null
//                               }
//                             >
//                               <Col xs={1}>
//                                 {find || findAnswer ? (
//                                   <IoMdCheckbox
//                                     size={30}
//                                     color="var(--primary-color)"
//                                   />
//                                 ) : option?.answer ? (
//                                   <IoMdCheckbox
//                                     size={30}
//                                     color="var(--primary-color)"
//                                   />
//                                 ) : (
//                                   <IoIosCheckboxOutline
//                                     size={30}
//                                     color="var(--primary-color)"
//                                   />
//                                 )}
//                               </Col>
//                               <Col xs={22}>
//                                 <TextComponent textClass={styles.optionText}>
//                                   {option?.name}
//                                 </TextComponent>
//                               </Col>
//                             </Row>
//                           </Col>
//                         </Row>
//                       );
//                     })}
//                   {item.type === "own_words" && (
//                     <textarea
//                       rows={5}
//                       disabled={item?.is_answer == 1 ? true : false}
//                       value={
//                         item.answer
//                           ? item?.answer
//                           : ownwords?.own_word
//                           ? ownwords?.own_word
//                           : ""
//                       }
//                       className={styles.textInput}
//                       placeholder="Type Here"
//                       onChange={(e) =>
//                         onValueChange(
//                           e.target.value,
//                           // option?.id,
//                           item?.type,
//                           item?.id
//                         )
//                       }
//                     ></textarea>
//                   )}
//                 </div>
//               )}
//             </Col>
//             <Col xs={2} className={styles.iconCol}>
//               <TextComponent
//                 textClass={styles.dropdownArrow}
//                 onClick={() => setDropdownOpen((prev) => !prev)}
//               >
//                 {dropdownOpen ? (
//                   <BiChevronUp className={styles.dropdownIcon} />
//                 ) : (
//                   <BiChevronDown className={styles.dropdownIcon} />
//                 )}
//               </TextComponent>
//             </Col>
//           </Row>
//         </Col>
//       </List.Item>
//     );
//   }
// );

// const QuestionSteps = ({
//   loading,
//   answerByClient,
//   setanswerByClient,
//   getSection,
// }) => {
//   const ClientQuestion = useSelector(
//     (state) => state.EventReducer.ClientQuestion
//   );
//   const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
//   const dispatch = useDispatch();
//   const planingForm = useLocation().state?.item;

//   // console.log("answerByClient========================", answerByClient);

//   const onPressRadioButton = (answer, answerID, type, questionID) => {
//     let find = answerByClient.find(
//       (element) => element?.question_id == questionID
//     );

//     let cpyArr = [...answerByClient];
//     if (find) {
//       const index = answerByClient.findIndex(
//         (element) => element?.question_id == questionID
//       );
//       cpyArr.splice(index, 1);
//       cpyArr.push({
//         question_id: questionID,
//         type: type,
//         option: answer,
//         answer_id: answerID,
//       });
//       // setRefresh(!Refresh);
//     } else {
//       cpyArr.push({
//         question_id: questionID,
//         type: type,
//         option: answer,
//         answer_id: answerID,
//       });
//       // setRefresh(!Refresh);
//     }
//     setanswerByClient(cpyArr);
//   };

//   const onPressCheckBox = (answer, answerID, type, questionID) => {
//     let findQuestion = answerByClient.find(
//       (element) => element?.question_id == questionID
//     );
//     if (findQuestion) {
//       let findAnswer = answerByClient.find(
//         (element) => element?.answer_id == answerID
//       );
//       if (findAnswer) {
//         let obj = answerByClient.find((x) => x === findAnswer);
//         let selected = answerByClient.indexOf(obj);
//         let cpyArr = [...answerByClient];
//         cpyArr.splice(selected, 1);
//         setanswerByClient(cpyArr);
//         // setRefresh(!Refresh);
//       } else {
//         let cpyArr = [...answerByClient];
//         cpyArr.push({
//           question_id: questionID,
//           type: type,
//           option: answer,
//           answer_id: answerID,
//         });
//         setanswerByClient(cpyArr);
//         // setRefresh(!Refresh);
//       }
//     } else {
//       let cpyArr = [...answerByClient];
//       cpyArr.push({
//         question_id: questionID,
//         type: type,
//         option: answer,
//         answer_id: answerID,
//       });
//       setanswerByClient(cpyArr);
//       // setRefresh(!Refresh);
//     }
//   };

//   const onValueChange = (answer, type, questionID) => {
//     let findQuestion = answerByClient.find(
//       (element) => element?.question_id == questionID
//     );
//     if (findQuestion) {
//       let obj = answerByClient.find((x) => x === findQuestion);
//       let selected = answerByClient.indexOf(obj);
//       let cpyArr = [...answerByClient];
//       cpyArr[selected].own_word = answer;
//       setanswerByClient(cpyArr);
//       // setRefresh(!Refresh);
//     } else {
//       let cpyArr = [...answerByClient];
//       cpyArr.push({
//         question_id: questionID,
//         type: type,
//         own_word: answer,
//       });
//       setanswerByClient(cpyArr);
//       // setRefresh(!Refresh);
//     }
//   };

//   const onPressDone = () => {
//     if (answerByClient?.length == 0) {
//       dispatch(
//         showAlert({
//           title: "Post answer by clien",
//           message: "No changes made!",
//           type: "Error",
//           status: 400,
//         })
//       );
//       return;
//     } else {
//       dispatch(
//         EventMiddleware.postAnswerByClient({
//           answerCollection: answerByClient,
//           planningtemplate_id: planingForm?.id,
//           event_id: EventDetails?.id,
//         })
//       )
//         .then(() => getSection())
//         .catch((err) => console.log(err));
//     }
//   };

//   return (
//     <Skeleton loading={loading}>
//       <Steps
//         direction="vertical"
//         current={ClientQuestion.length - 1}
//         style={{ margin: "40px auto 20px auto" }}
//       >
//         {ClientQuestion.map((item, index) => (
//           <Steps.Step
//             key={item.id}
//             // title="In Progress"
//             title={
//               <RenderQuestion
//                 item={item}
//                 index={index}
//                 answerByClient={answerByClient}
//                 onPressRadioButton={onPressRadioButton}
//                 onPressCheckBox={onPressCheckBox}
//                 onValueChange={onValueChange}
//               />
//             }
//             icon={
//               <svg
//                 width="20"
//                 height="20"
//                 viewBox="0 0 36 36"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   fill-rule="evenodd"
//                   clip-rule="evenodd"
//                   d="M0.433594 17.7695C0.433594 8.21132 8.18788 0.457031 17.7461 0.457031C27.3043 0.457031 35.0586 8.21132 35.0586 17.7695C35.0586 27.3277 27.3043 35.082 17.7461 35.082C8.18788 35.082 0.433594 27.3277 0.433594 17.7695ZM17.7461 3.12049C9.65887 3.12049 3.09706 9.68231 3.09706 17.7695C3.09706 25.8568 9.65887 32.4186 17.7461 32.4186C25.8333 32.4186 32.3951 25.8568 32.3951 17.7695C32.3951 9.68231 25.8333 3.12049 17.7461 3.12049Z"
//                   fill="var(--primary-color)"
//                 />
//                 <path
//                   d="M17.7524 28.9305C23.9172 28.9305 28.9149 23.9329 28.9149 17.768C28.9149 11.6031 23.9172 6.60547 17.7524 6.60547C11.5875 6.60547 6.58984 11.6031 6.58984 17.768C6.58984 23.9329 11.5875 28.9305 17.7524 28.9305Z"
//                   fill="var(--primary-color)"
//                 />
//               </svg>
//             }
//           />
//         ))}
//       </Steps>

//       <SubmitButton
//         title={"Submit"}
//         btnClass={styles.submitBtn}
//         onClick={onPressDone}
//       />
//     </Skeleton>
//   );
// };

const PlanningFormSection = () => {
  const [topic, setTopic] = useState("");
  const [loading, setloading] = useState(false);
  const [answerByClient, setanswerByClient] = useState([]);
  const ClientSection = useSelector(
    (state) => state.EventReducer.ClientSection
  );
  const ClientQuestion = useSelector(
    (state) => state.EventReducer.ClientQuestion
  );
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const dispatch = useDispatch();
  const { state } = useLocation();

  const routeData = state?.item;

  useEffect(() => {
    getSection();
  }, []);

  // const getClientQueston = (id) => {
  //   setloading(true);
  //   let secdata = {
  //     templatesection_id: id,
  //     event_id: EventDetails?.id,
  //   };
  //   dispatch(EventMiddleware.getClientQuestions(secdata))
  //     .then(() => {
  //       setanswerByClient([]);
  //       setloading(false);
  //     })
  //     .catch((err) => {
  //       setloading(false);
  //       // console.log(err);
  //     });
  // };
  // console.log("routeData", routeData);
  const getSection = () => {
    // setloading(true);
    let tempData = {
      planningtemplate_id: routeData?.id,
      event_id: EventDetails?.id,
    };
    dispatch(EventMiddleware.getClientsection(tempData)).then((data) => {
      if (data?.length > 0) {
        setTopic(data?.[0]);
        // getClientQueston(data?.[0]?.id);
      }
    });
    // .catch(err => {
    //   setloading(false);
    //   console.log(err);
    // });
  };

  // console.log("ClientSection", ClientSection);
  // console.log("ClientQuestion", ClientQuestion);

  return (
    <Row>
      <Col className={styles.leftCol}>
        <Row className={styles.eventTitleRow}>
          <TextComponent textClass={styles.eventTitle}>
            {EventDetails?.name}
          </TextComponent>
        </Row>
        <Row className={styles.avatarRow} gutter={8}>
          <Col xs={6} sm={4} lg={4} xl={2} xxl={2}>
            <img
              src={routeData?.vendor_image ? routeData?.vendor_image : dummy}
              alt=""
              style={{ width: "100%", borderRadius: "100%" }}
            />
          </Col>
          <Col xs={18} sm={20}>
            <Row>
              <TextComponent textClass={styles.name}>
                {routeData?.vendor_name}
              </TextComponent>
            </Row>
            <Row>
              <TextComponent textClass={styles.profession}>
                {routeData?.vendor_category}
              </TextComponent>
            </Row>
          </Col>
        </Row>
        {/* <Row className={styles.inputRow} gutter={8}>
          <Col xs={24} sm={17}>
            <SearchInput placeholder="Search Section" />
          </Col>
          <Col xs={24} sm={7}>
            <SubmitButton title="Search" btnClass={styles.btn} />
          </Col>
        </Row> */}
        <List
          // grid={{ xs: 1, xl: 3 }}
          className={styles.planningItemsList}
          dataSource={ClientSection ? ClientSection : []}
          renderItem={(item, index) => (
            <RenderPlanningItem
              key={item?.id}
              title={item.name}
              item={item}
              index={index}
              // getClientQueston={getClientQueston}
              progress={
                item?.total_question > 0
                  ? (parseInt(item?.total_answer_by_client) * 100) /
                    parseInt(item?.total_question)
                  : 0
              }
              setTopic={setTopic}
            />
          )}
        />
      </Col>
      {/* <Col xs={24} lg={16} className={styles.rightCol}>
        <Row className={styles.headingRow}>
          <Col>
            <TextComponent textClass={styles.heading}>
              {topic?.name}
            </TextComponent>
            &nbsp;
            <TextComponent textClass={styles.headingNumbers}>
              {ClientSection?.length > 0
                ? `(${topic?.total_answer_by_client} / ${topic?.total_question})`
                : ""}
            </TextComponent>
          </Col>
          <Col>
            <TextComponent textClass={styles.smallText}>
              Let’s get connected!
            </TextComponent>
          </Col>
        </Row>
        <QuestionSteps
          loading={loading}
          answerByClient={answerByClient}
          setanswerByClient={setanswerByClient}
          getSection={getSection}
        />
      </Col> */}
    </Row>
  );
};

export default PlanningFormSection;
